import { DEVICE_ROLES } from '@/features/core/container';
import { MetricResolutionAggregator, MetricResolutionTimeSource, SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './general-meter-water-meter-hot-lg.svg';
import md from './general-meter-water-meter-hot-md.svg';
import sm from './general-meter-water-meter-hot-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.GENERAL_METER_WATER_METER_HOT,
  label: 'Allgemeinzähler_Warmwasserzähler',
  shortLabel: 'All_Warmw',
  icons: { sm, md, lg },
  component: component('general-meter-water-meter-hot/GeneralMeterHotWaterMeterDevicePanel.vue'),
  props: { volumeColor: 'RED' },
  aggregationWidget: {
    enabled: true,
    component: component('general-meter-water-meter-hot/GeneralMeterHotWaterMeterAggregationWidget.vue'),
    props: { digitColor: 'RED' },
  },
  defaultMetricNames: ['currentVolume'],
  importantMetricNames: ['currentVolume', 'currentFlow'],
  aggregationMetricNames: [
    {
      name: 'currentVolume',
      aggregators: [MetricResolutionAggregator.SUM],
      timeSource: MetricResolutionTimeSource.START,
    },
  ],
  consumption: true,
}));
